<template>
    <el-form :model="stationSearchForm" ref="stationSearchForm" size="mini" :inline="true" :rules="searchFormRules">
      <el-col :span="3">
        <el-form-item prop="operatorId">
          <el-cascader  size="mini" clearable ref="cascader"
                        placeholder="运营商"  filterable
                        :options="operatorForSelect"
                        :props="{ checkStrictly:true,expandTrigger:'hover'}"
                        :show-all-levels="false"
                        change-on-select
                        @change='handleChangeOperator'
                        v-model="stationSearchForm.operatorId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item prop="stationId">
          <el-select placeholder="所属站" v-model="stationSearchForm.stationId" clearable>
            <el-option v-for="item in stationsForSelect" :key="item.id"
                       v-bind:label="item.stationName" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item prop="stationName">
          <el-input placeholder="充电站名称" v-model="stationSearchForm.stationName" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item prop="dutyPerson">
          <el-input placeholder="客户联系人" v-model="stationSearchForm.dutyPerson" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item prop="salesman">
          <el-input placeholder="销售人" v-model="stationSearchForm.salesman" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1.5">
        <el-form-item>
          <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
        </el-form-item>
      </el-col>
      <el-col :span="1.5">
        <el-form-item>
          <el-button type="primary"  icon="el-icon-search" @click="submitSafetySearchForm"
                     :loading="getStationsLoading">查询
          </el-button>
        </el-form-item>
      </el-col>
    </el-form>
</template>

<script>
  import {validateInput} from '../../../../common/validator'
  export default {
    name: "search",
    data(){
      return{
        searchFormRules: {
        }
      }
    },
    props:{
      stationSearchForm: {},
      operatorForSelect: '',
      stationsForSelect: '',
      getStationsLoading:false,
    },
    mounted:function(){
      this.$emit('submitSafetySearchForm')
    },
    methods:{
      resetSearchForm() {
        for(let item in this.stationSearchForm) {
          if(this.stationSearchForm[item]){
            this.stationSearchForm[item] = ''
          }
        }
        this.submitSafetySearchForm()
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.stationSearchForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      submitSafetySearchForm(){
        this.$emit('submitSafetySearchForm')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/safetyManager/search.vue